import { getAllDict } from '@/api/modules/sys/dict'

/**
 * 字典缓存对象
 */
let dictCache = {}
let dictReady = false

/**
 * 初始化字典数据
 * @returns {Promise}
 */
export function initDictCache() {
  return new Promise((resolve, reject) => {
    getAllDict()
      .then(res => {
        if (res.code === 0) {
          dictCache = res.data || {}
          dictReady = true
          console.log('字典数据初始化成功')
          resolve(dictCache)
        } else {
          reject(new Error('字典数据初始化失败'))
        }
      })
      .catch(error => {
        console.error('字典数据初始化失败:', error)
        reject(error)
      })
  })
}

/**
 * 获取字典选项列表
 * @param {String} dictCode 字典编码
 * @returns {Array} 选项列表 [{label, value}]
 */
export function getDictOptions(dictCode) {
  if (!dictReady) {
    console.warn('字典尚未准备好，请确保在使用前已调用initDictCache')
    return []
  }
  
  const dictItems = dictCache[dictCode] || []
  return dictItems.map(item => ({
    label: item.itemName,
    value: item.itemCode
  }))
}

/**
 * 获取字典标签
 * @param {String} dictCode 字典编码
 * @param {String} itemCode 字典项编码
 * @param {Boolean} useEnName 是否使用英文名称
 * @returns {String} 字典项名称
 */
export function getDictLabel(dictCode, itemCode, useEnName = false) {
  if (!dictReady) {
    console.warn('字典尚未准备好，请确保在使用前已调用initDictCache')
    return itemCode
  }
  
  const dictItems = dictCache[dictCode] || []
  const dictItem = dictItems.find(item => item.itemCode === itemCode)
  
  if (!dictItem) {
    return itemCode
  }
  
  return useEnName ? dictItem.itemNameEn : dictItem.itemName
}

/**
 * 获取字典项值
 * @param {String} dictCode 字典编码
 * @param {String} itemName 字典项名称
 * @returns {String} 字典项编码
 */
export function getDictValue(dictCode, itemName) {
  if (!dictReady) {
    console.warn('字典尚未准备好，请确保在使用前已调用initDictCache')
    return itemName
  }
  
  const dictItems = dictCache[dictCode] || []
  const dictItem = dictItems.find(
    item => item.itemName === itemName || item.itemNameEn === itemName
  )
  
  return dictItem ? dictItem.itemCode : itemName
}

/**
 * 刷新字典缓存
 * @returns {Promise}
 */
export function refreshDictCache() {
  return initDictCache()
}

/**
 * 判断字典是否准备好
 * @returns {Boolean}
 */
export function isDictReady() {
  return dictReady
}

/**
 * 获取所有字典项
 * @returns {Object} 字典数据对象
 */
export function getAllDictItems() {
  return dictCache
} 